import { Subscribable } from 'rxjs/Observable';
import {
    animate,
    Component,
    ComponentFactoryResolver,
    ComponentRef,
    Inject,
    Input,
    PLATFORM_ID,
    SimpleChange,
    state,
    style,
    transition,
    trigger,
    ViewChild,
    ViewContainerRef,
    ComponentFactory
} from '@angular/core';
import { ActivatedRoute, Router} from '@angular/router';
import { GridContainer } from '../grid-container/grid-container.component';
import { ProfileContainer } from '../profile-container/profile-container.component';
import { EventContainer } from '../event-container/event-container.component';
import { DocumentContainer } from '../document-container/document-container.component';
import { PlaceContainer } from '../place-container/place-container.component';
import { PageContainer } from '../page-container/page-container.component';
import { VideoContainer } from '../video-container/video-container.component';
import { EmbedVideoContainer } from '../video-container/embed/embed.video-container.component';
import { ListContainer } from '../list-container/list-container.component';
import { TagsContainer } from '../tags-container/tags-container.component';
import { StaticContainer } from 'angular-shared-features/feature/shared-component/static-container.component';
import { SeriesContainer } from '../series-container/series-container.component';
import { SeasonContainer } from '../season-container/season-container.component';
import { FormContainer } from '../form-container/form-container.component';
import { PlaylistContainer } from '../playlist-container/playlist-container.component';
import { SearchContainer } from '../search-container/search-container.component';
import { NotFoundContainer } from '../notfound-container/notfound-container.component'
import { Subscription } from 'rxjs/Rx';
import { CoreEffects } from 'angular-engine/engine/state/effect/core.effects';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { DEVICE_INFO, APP_SETTINGS,  DeviceInfo } from 'angular-engine/modules/ng-express-engine/tokens';
import { EmbeddedViewRef } from '@angular/core/src/linker/view_ref';

@Component({
  selector: 'dynamic-container',
  template: `
<div [@toggle]="show"
        (@toggle.start)="animationStarted($event)"
        (@toggle.done)="animationDone($event)">
  <ng-container #dynamicCompPlaceholder></ng-container>
</div>
`,
entryComponents:[
//         GridContainer,
//         FormContainer,
//         EventContainer,
//         ProfileContainer,
//         DocumentContainer,
//         PlaceContainer,
//         VideoContainer,
//         ListContainer,
//         SeriesContainer,
//         PlaylistContainer,
//         SearchContainer,
//         PageContainer,
//         NotFoundContainer,
//         TagsContainer
    ],
    animations: [
      trigger('toggle', [
      state('active', style({ opacity: 1 })),
      state('inactive', style({ opacity: 0 })),
      state('void', style({ opacity: 0 })),
      transition('active => inactive', animate('500ms ease-in-out')),
      transition('inactive => active', animate('500ms ease-in-out')),
      transition(':leave', animate('500ms ease-in-out')),
    ])
   ]
})
export class DynamicComponentContainer
{
    protected wasViewInitialized = false;
    @ViewChild('dynamicCompPlaceholder', {read: ViewContainerRef})
    protected dynamicComponentTarget: ViewContainerRef;
    protected componentRef: ComponentRef<any> = null;
    protected subscription: Subscription;
    protected routerSubscription: Subscription;
    protected dataSubscription: Subscription;
    protected factory: ComponentFactory<any>;
    private routingActive = false;
    private redirect = false;
    private isServer:boolean;

     @Input() show:string = "active";

    constructor(
        protected activeRoute: ActivatedRoute,
        protected router: Router,
        protected componentFactoryResolver: ComponentFactoryResolver,
        private coreEffects: CoreEffects,
        @Inject(PLATFORM_ID) private platformId: string,
        @Inject(APP_SETTINGS) protected settings: Object,
        @Inject(DEVICE_INFO) private deviceInfo: DeviceInfo
    ) {
        this.isServer = isPlatformServer(this.platformId);
    }

    ngOnInit() {
        this.routerSubscription = this.router.events.pairwise().subscribe((e) => {
            this.routingActive = true;
        });
        this.subscription = this.activeRoute.params.subscribe(res => {
            const url = this.router.url;
            /*if ((url.match(/^\/playlists\//) && (url.indexOf('videos/') > -1 || url.indexOf('episodes/') > -1 )) || url.match(/^\/streams\//)){
                this.routingActive = false;
            }*/
            if(this.routingActive && !this.redirect)
            {
                this.show="inactive";
            }
            else
            {
//                 if (this.componentRef) {
//                     this.componentRef.destroy();
//                 }
                let routerUrl = this.router.url;
                if (routerUrl.indexOf('undefined') > -1){
                    routerUrl = null;
                }
                if (routerUrl){
                    this.refreshContent();
                }
            }

        })

    }

    animationStarted($event) {

    }


    animationDone($event) {
        if($event.toState != "active"){
            if (this.componentRef) {
                this.componentRef.destroy();
            }
            this.refreshContent();
        }
    }

    public refreshContent(){
        this.dynamicComponentTarget.clear();
        this.redirect = false;

        if (this.componentRef) {
            this.componentRef.destroy();
        }



        this.dataSubscription = this.coreEffects.getRouteDataAsObservable(this.activeRoute.snapshot.params).subscribe(data => {
            if(!data)
            {
                this.factory = this.componentFactoryResolver.resolveComponentFactory(NotFoundContainer);
                this.componentRef = this.dynamicComponentTarget.createComponent(this.factory);
            }
            else{
                const url = this.router.url;
                if(url.match(/^\/playlists\//) && (url.indexOf('videos/') < 0 && url.indexOf('episodes/') < 0)){
                    if (data.data && Array.isArray(data.data)){
                        const slug = data.data[0]['meta']['slug']
                        let goTo = this.router.url + "/videos/" + slug;
                        if(data.data[0]['meta']['obj_type'] == "Episode")
                        {
                            goTo = this.router.url + "/episodes/" + slug;
                        }
                        this.navigate(goTo);
                        //this.router.navigateByUrl(goTo);
                    }
                }
                else if(url.match(/^\/streams\//))
                {
                    if(data.meta && data.meta.video && data.meta.video.meta){
                        const slug = data.meta.video.meta.slug;
                        let goTo = "/videos/" + slug;
                        this.navigate(goTo);
                    }
                    else{
                        this.factory = this.getComponentFactory();
                        this.componentRef = this.dynamicComponentTarget.createComponent(this.factory);
                    }
                }
                else{
                    this.factory = this.getComponentFactory();
                    this.componentRef = this.dynamicComponentTarget.createComponent(this.factory);
                }
            }

            this.show = "active";
        });

    }

    private navigate(url){
        url = (this.router.url.indexOf('embed/') > -1 && url.indexOf('embed/') < 0) ? '/embed' + url : url;
        this.redirect = true;
        this.router.navigateByUrl(url);
    }

    private get404Factory(){

    }

    private getComponentFactory(){
        const url = (this.router && this.router.url) ? this.router.url : '';

        if (!url) {
            return this.componentFactoryResolver.resolveComponentFactory(GridContainer);
        }
        const paramObj = this.activeRoute.snapshot.params;

        if (url.match(/^\/events\//)){
            return this.componentFactoryResolver.resolveComponentFactory(EventContainer);
        }

        if (url.match(/^\/contact/)){
            return this.componentFactoryResolver.resolveComponentFactory(FormContainer);
        }

        if (url.match(/^\/search/)){
            return this.componentFactoryResolver.resolveComponentFactory(SearchContainer);
        }
        if (url.match(/^\/tags\//)){
            return this.componentFactoryResolver.resolveComponentFactory(TagsContainer);
        }

        if (url.match(/^\/series\//)){
            return this.componentFactoryResolver.resolveComponentFactory(SeriesContainer);
        }

        if (url.match(/^\/seasons\//)){
            return this.componentFactoryResolver.resolveComponentFactory(SeasonContainer);
        }

        if (url.match(/^\/profiles\//)){
            return this.componentFactoryResolver.resolveComponentFactory(ProfileContainer);
        }

        if (url.match(/^\/places\//)){
            return this.componentFactoryResolver.resolveComponentFactory(PlaceContainer);
        }

        if (url.match(/^\/pages\//)){
            return this.componentFactoryResolver.resolveComponentFactory(PageContainer);
        }
        if (url.match(/^\/embed\//)){
            return this.componentFactoryResolver.resolveComponentFactory(EmbedVideoContainer);
        }

        if (url.match(/^\/videos\//) || url.match(/^\/episodes\//) || url.match(/^\/streams\//)){
            if (url.match(/^\/embed\//)){
                return this.componentFactoryResolver.resolveComponentFactory(EmbedVideoContainer);
            }
            else{
                return this.componentFactoryResolver.resolveComponentFactory(VideoContainer);
            }

        }

        if (url.match(/^\/lists\//)){
            return this.componentFactoryResolver.resolveComponentFactory(ListContainer);
        }

        if (url.match(/^\/documents\//)){
            return this.componentFactoryResolver.resolveComponentFactory(DocumentContainer);
        }

        if (url.match(/^\/playlists\//) && (url.indexOf('videos/') > -1 || url.indexOf('episodes/') > -1 )){
            return this.componentFactoryResolver.resolveComponentFactory(PlaylistContainer);
        }

        return this.componentFactoryResolver.resolveComponentFactory(GridContainer);
    }

    public ngOnDestroy(){

        this.factory = null;

        if (this.componentRef) {
            this.componentRef.destroy();
        }
        if (this.dataSubscription){
            this.dataSubscription.unsubscribe();
        }
        if(this.subscription)
        {
            this.subscription.unsubscribe();
        }

        if(this.routerSubscription)
        {
            this.routerSubscription.unsubscribe();
        }

    }
}



// WEBPACK FOOTER //
// ./src/angular-framework-client-components/containers/notfound-container/dynamic-container.component.ts